// extracted by mini-css-extract-plugin
export default {"wrapper":"NoDataFound_wrapper__ArHX0","card":"NoDataFound_card__F4J4Q","title":"NoDataFound_title__wMEMq"};